import { render, staticRenderFns } from "./TheAddSail.vue?vue&type=template&id=380d742e&scoped=true&"
import script from "./TheAddSail.vue?vue&type=script&lang=js&"
export * from "./TheAddSail.vue?vue&type=script&lang=js&"
import style0 from "./TheAddSail.vue?vue&type=style&index=0&id=380d742e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d742e",
  null
  
)

export default component.exports